export default defineAppConfig({
  ui: {
    primary: 'yellow',
    gray: 'slate',
  },
});
